import { render, staticRenderFns } from "./create-orders.vue?vue&type=template&id=fba82b58&scoped=true"
import script from "./create-orders.vue?vue&type=script&lang=js"
export * from "./create-orders.vue?vue&type=script&lang=js"
import style0 from "./create-orders.vue?vue&type=style&index=0&id=fba82b58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba82b58",
  null
  
)

export default component.exports